import toast from 'react-hot-toast';
import SDK from '../../config';
import SubscriptionService from '../../services/subscriptionService';
import handlePaymentSuccessLifetime from './handlePaymentSuccessLifetime';
import handlePaymentSuccessSubscription from './handlePaymentSuccessSubscription';

export const handleSubmit = async (
  event,
  stripe,
  elements,
  email,
  CardNumberElement,
  cardName,
  setPageLoader,
  navigate,
  referralCode
) => {
  const selectedPlan = SDK.getSelectedPlan();
  if (!selectedPlan) {
    toast.error('No plan selected.');
    navigate('/');
    return;
  }
  const BASE_URL = SDK.getBaseUrl(selectedPlan.pageType);
  const paymentOf = 'friends_iOS';

  event.preventDefault();
  if (!stripe || !elements) {
    return;
  }
  const cardNumberElement = elements.getElement(CardNumberElement);
  if (!cardNumberElement) {
    console.error('CardNumberElement not found');
    return;
  }


  setPageLoader(true);
  // ============================================
  // Lifetime Payment Processing
  // ===========================================
  const type = SDK.PAGE_TYPE;
  if (selectedPlan.type === 'Lifetime') {
    try {
      // const price = selectedPlan.price * 100;
      const price = 0 * 100;
      const region = localStorage.getItem('region') || 'us';
      const { currency } = SDK.REGION_CONFIG[region] || SDK.REGION_CONFIG['us'];

      // Create Payment Intent
      const createIntent = await fetch(
        `${BASE_URL}/api/create-payment-intent`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
            paymentOf,
            regionCur: currency,
            type,
            price,
            selectedPlan,
          }),
        }
      );

      if (!createIntent.ok) {
        const err = await createIntent.json();
        console.error('Payment intent error:', err.error);
        toast.error('Failed to create payment intent.');
        return;
      }
      const { clientSecret } = await createIntent.json();
      // Confirm Card Payment
      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardNumberElement,
          billing_details: { name: cardName },
        },
      });

      if (result.error) {
        toast.error('Invalid Card Details');
        return;
      }

      if (result.paymentIntent.status === 'succeeded') {
        const methodType = 'Debit Card';
        await handlePaymentSuccessLifetime(
          result.paymentIntent,
          methodType,
          cardName,
          email,
          paymentOf
        );

        // Save email
        // await fetch(`${BASE_URL}/api/save-email`, {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ email }),
        // });

        navigate(`/confirmation?email=${encodeURIComponent(email)}`);
        toast.success('Payment Successful');

        SDK.clearAllLocalStorage();
      }
    } catch (err) {
      console.error('Lifetime payment error:', err);
      toast.error('Payment failed. Please try again.');
    } finally {
      setPageLoader(false);
    }
    return;
  }

  // ============================================
  // Subscription Payment Processing
  // ============================================
  try {
    const alreadySubscribed =
      await SubscriptionService.checkSubscriptionStatus(email);
    if (alreadySubscribed) {
      toast.error(
        'This email has an active subscription. Please change the email address.'
      );
      return;
    }
    const region = localStorage.getItem('region') || 'us';
    const { currency } = SDK.REGION_CONFIG[region] || SDK.REGION_CONFIG['us'];
    const payload = {
      email,
      paymentOf,
      regionCur: currency,
      cardName,
      referralCode
     
    };
    // Create SetupIntent for subscription
    const initPayment = await SubscriptionService.intializePayment(payload);
    if (!initPayment || !initPayment.client_secret) {
      toast.error('Failed to create payment intent.');
      return;
    }

    const { client_secret, customer } = initPayment;
    // Confirm card setup
    const result = await stripe.confirmCardSetup(client_secret, {
      payment_method: {
        card: cardNumberElement,
        billing_details: { name: cardName },
      },
    });
    if (result.error) {
      toast.error('Invalid Card Details');
      return;
    }
    if (result.setupIntent.status === 'succeeded') {

      const paymentMethodId = result.setupIntent.payment_method;
      const setupIntentId = result.setupIntent.id;

      const responsePayment = await handlePaymentSuccessSubscription({
        setupIntentId,
        paymentMethodId,
        paymentMethodType: 'Debit Card',
        cardHolderName: cardName,
        customerEmail: email,
        billingZipcode: 4444,
        platformUsed: paymentOf,
        customerId: customer,
        navigate,
        referralCode
      });
      console.log('responsePayment:', responsePayment);
      if (!responsePayment.success) {
        toast.error('Failed to save payment details.');
        return;
      }
      toast.success('Payment Successful');
      
      navigate(`/confirmation?email=${encodeURIComponent(email)}`);
      SDK.clearAllLocalStorage();
    }
  } catch (err) {
    console.error('Subscription payment error:', err);
    toast.error('Payment failed. Please try again.');
  } finally {
    setPageLoader(false);
  }
};
